import React from 'react';
import { SwitchProps } from '@mui/material';
import * as Styled from './switch.styles';

const Switch: React.FC<SwitchProps> = (props) => {
  return <Styled.Switch {...props} />;
};

export default React.memo(Switch);
